import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { DatabaseIcon, HardDriveIcon, CpuIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function AppendixA3Slide() {
  return <SlideLayout data-id="element-58">
      <motion.div variants={itemVariants} className="mb-12" data-id="element-59">
        <p className="text-brand-teal font-mono text-xs tracking-widest uppercase mb-3" data-id="element-60">
          Appendix A3
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-61">
          Memory Architecture Advantage
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-62">
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8" data-id="element-63">
          <div className="flex items-center gap-3 mb-6" data-id="element-64">
            <div className="p-3 bg-brand-teal/10 rounded-lg border border-brand-teal/20" data-id="element-65">
              <HardDriveIcon className="w-6 h-6 text-brand-teal" data-id="element-66" />
            </div>
            <h3 className="text-xl font-bold text-brand-text" data-id="element-67">
              Bare-Metal Operation
            </h3>
          </div>
          <ul className="space-y-4 text-brand-text-dim" data-id="element-68">
            <li className="flex items-start gap-3" data-id="element-69">
              <span className="text-brand-teal mt-1" data-id="element-70">•</span>
              <span data-id="element-71">
                100% of memory bandwidth reserved for model weights and KV cache
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-72">
              <span className="text-brand-teal mt-1" data-id="element-73">•</span>
              <span data-id="element-74">
                No operating system, no virtual memory paging, no context
                switching
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-75">
              <span className="text-brand-teal mt-1" data-id="element-76">•</span>
              <span data-id="element-77">
                Every byte of bandwidth serves inference — zero overhead
              </span>
            </li>
          </ul>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8" data-id="element-78">
          <div className="flex items-center gap-3 mb-6" data-id="element-79">
            <div className="p-3 bg-brand-teal/10 rounded-lg border border-brand-teal/20" data-id="element-80">
              <DatabaseIcon className="w-6 h-6 text-brand-teal" data-id="element-81" />
            </div>
            <h3 className="text-xl font-bold text-brand-text" data-id="element-82">
              Custom Memory Hierarchies
            </h3>
          </div>
          <ul className="space-y-4 text-brand-text-dim" data-id="element-83">
            <li className="flex items-start gap-3" data-id="element-84">
              <span className="text-brand-teal mt-1" data-id="element-85">•</span>
              <span data-id="element-86">
                BRAM/URAM buffers sized for exact model access patterns
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-87">
              <span className="text-brand-teal mt-1" data-id="element-88">•</span>
              <span data-id="element-89">Multi-level caching tuned per layer, per operator</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-90">
              <span className="text-brand-teal mt-1" data-id="element-91">•</span>
              <span data-id="element-92">Data reuse maximized at every level of the hierarchy</span>
            </li>
          </ul>
        </motion.div>
      </div>

      {/* Key Stat */}
      <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-teal/30 rounded-2xl p-8 flex flex-col md:flex-row items-center gap-8 max-w-4xl mx-auto" data-id="element-93">
        <div className="flex-shrink-0" data-id="element-94">
          <div className="p-4 bg-brand-teal/10 rounded-xl border border-brand-teal/20" data-id="element-95">
            <CpuIcon className="w-10 h-10 text-brand-teal" data-id="element-96" />
          </div>
        </div>
        <div data-id="element-97">
          <div className="text-5xl font-bold text-brand-teal mb-2" data-id="element-98">3,136×</div>
          <p className="text-lg text-brand-text font-medium mb-1" data-id="element-99">
            Weight Reuse Factor
          </p>
          <p className="text-sm text-brand-text-dim" data-id="element-100">
            Measured in FlightLLM benchmarks. Custom on-chip buffers allow each
            weight to be reused thousands of times before being evicted —
            dramatically reducing external memory traffic.
          </p>
        </div>
      </motion.div>
    </SlideLayout>;
}